import { useBuyerNavigationLayoutContext } from '@/enterprise/components/BuyerNavigationLayout';
import LegacyAwardedInvoices from '@/enterprise/features/awardedInvoiceTable/LegacyAwardedInvoices';
import { AwardedInvoicesView } from '@/enterprise/features/invoiceTables/awarded';
import useFeature from '@/lib/features';
import { useReporting } from '@/reporting';

/**
 * Division Details → Awarded.
 * FF off: Node legacy table. FF on: shared SEA clearing-invoice view.
 * No CSV on this tab.
 */
const AwardedInvoices = () => {
  const [invoiceApiMigrationEnabled] = useFeature('enterprise-ui_invoiceApiMigration');
  const { trackEnterpriseEvent } = useReporting();
  const { takerMarket, urlParams } = useBuyerNavigationLayoutContext();

  if (!invoiceApiMigrationEnabled) {
    return <LegacyAwardedInvoices />;
  }

  return (
    <AwardedInvoicesView
      source={{
        makerOrganizationUuid: urlParams.makerOrganizationUuid,
        currency: takerMarket.currency,
        takerMarkets: [takerMarket],
      }}
      actions={{
        onSort: ({ sortKey, sortDirection }) => {
          trackEnterpriseEvent('invoice-sort::clicked', { key: sortKey, direction: sortDirection });
        },
        onPageChange: () => {
          trackEnterpriseEvent('invoice-page::clicked');
        },
        onPageSizeChange: ({ size }) => {
          trackEnterpriseEvent('invoice-page-size::clicked', { size });
        },
      }}
    />
  );
};

export default AwardedInvoices;
